module.exports = __webpack_public_path__ + "img/PF.928fa3b8.svg";